import React, {useEffect, useState, useRef} from 'react';
import {Card, Col, Row, Table, Button, Pagination} from "react-bootstrap";
import styles from './admin-investor-registration-list.module.scss';
import Loading from "../../../../components/loading/loading";
import detailsArrowIcon from "../../../../assets/table-details-arrow.svg";
import {
  REGISTRATION_BP_ASSIGNED, REGISTRATION_CANCELLED,
  REGISTRATION_COMPLETED,
  REGISTRATION_PENDING_CONFIRMATION, REGISTRATION_PENDING_PDTC_PROCESSING,
  REGISTRATION_PENDING_SUBMISSION, REGISTRATION_REJECTED,
} from "../../../../helpr/constants";
import usePagination from "../../../../hooks/use-pagination";
import paginationLeftIcon from "../../../../assets/pagination-arrow-left.svg";
import paginationRightIcon from "../../../../assets/pagination-arrow-right.svg";
import ModalCustom from "../../../../components/modal/modal";
import SecondaryMarketService from "../../../../services/secondary-market-service";
import Registration from "../../../../models/registration";
import {toCurrency} from "../../../../helpr/helper";
import AdminRegistrationDetailsModalContent from "./components/admin-registration-details/admin-registration-details";

const AdminInvestorRegistrationList = () => {
  //Set spinner state
  const [loading, setLoading] = useState(true);
  //Set trade list state
  const [registrationList, setRegistrationList] = useState([]);
  const selectedRegistration = useRef({});
  //Modal State
  const [showModal, setShowModal] = useState(false);
  const [showRegistrationDetailsModal, setShowRegistrationDetailsModal] = useState(false);
  //Page data
  const pagedData = usePagination(registrationList,10);
  const pages = Array(pagedData.maxPage).fill().map((_, i) =>
    <Pagination.Item
      key={i+1}
      active={(i+1) === pagedData.currentPage}
      onClick={() => pagedData.jump(i+1)}>
      {i+1}
    </Pagination.Item>);
  //Initialize Service
  const secondaryMarketService = new SecondaryMarketService();
  //Table Headers
  const headers = [
    "Ref No.",
    "Broker",
    "ISIN",
    "Investor",
    "Face Amount",
    "Last Update Date",
    "Status",
    ""
  ]

  useEffect(()=> {
    const retrieveRegistrations = async () => {
      try {
        const result = await secondaryMarketService.getListOfRegistrations()
        const registrationList = result.map(r => new Registration(r));
        setRegistrationList(registrationList);
      } catch(error){

      } finally {
        setLoading(false);
      }

    }
    retrieveRegistrations();
    // eslint-disable-next-line
  }, []);

  const showRegistrationDetails = (registration) => {
    selectedRegistration.current = registration;
    setShowRegistrationDetailsModal(true)
  }

  return loading ? <Loading /> : (
    <div className={styles['admin-investor-registration-list-table']}>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h1>Investor Registrations</h1>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Table responsive>
                    <thead>
                    <tr>
                      {headers.map(
                        (header, index) => {
                          return <th key={index}>{header}</th>
                        }
                      )}
                    </tr>
                    </thead>
                    <tbody>
                    {
                      pagedData.currentData().map((r, index) => {
                        return (
                          <tr key={index}>
                            <td>{r.registrationId}</td>
                            <td>{r.brokerName}</td>
                            <td>{r.securityId}</td>
                            <td>{`${r.firstName} ${r.lastName}`}</td>
                            <td>{toCurrency(r.faceAmount)}</td>
                            <td>{r.lastUpdatedDate}</td>
                            <td>{renderStatus(r.registrationStatus, r.rejectReason)}</td>
                            <td className={styles['detail-arrow']} onClick={() => showRegistrationDetails(r)}>
                              <img alt="See Details" src={detailsArrowIcon} />
                            </td>
                          </tr>
                        )
                      })
                    }
                    </tbody>
                  </Table>
                  {
                    pagedData.maxPage > 0
                      ? <Pagination>
                        <Pagination.First
                          onClick={() => pagedData.jump(1)}
                          disabled={pagedData.currentPage === 1}>
                          <img alt="FIRST" src={paginationLeftIcon}/>
                        </Pagination.First>
                        <Pagination.Prev
                          onClick={() => pagedData.jump(pagedData.currentPage - 1)}
                          disabled={pagedData.currentPage === 1}>
                          PREV
                        </Pagination.Prev>
                        {pages}
                        <Pagination.Next
                          onClick={() => pagedData.jump(pagedData.currentPage + 1)}
                          disabled={pagedData.currentPage === pagedData.maxPage}>
                          NEXT
                        </Pagination.Next>
                        <Pagination.Last
                          onClick={() => pagedData.jump(pagedData.maxPage)}
                          disabled={pagedData.currentPage === pagedData.maxPage}>
                          <img alt="LAST" src={paginationRightIcon}/>
                        </Pagination.Last>
                      </Pagination> :
                      <div className={styles['no-data']}>No investor registrations to confirm.</div>
                  }
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ModalCustom
        show={showModal}
        title="Send Investor Registration Application"
        onClose={() => setShowModal(false)}
        component={<div></div>}
        // component={<RegistrationModalContent context={{setRegistrationList}} onClose={() => setShowModal(false)}/>}
        style={styles['registration-modal']} />
      <ModalCustom
        show={showRegistrationDetailsModal}
        title="Investor Registration Details"
        onClose={() => setShowRegistrationDetailsModal(false)}
        component={<AdminRegistrationDetailsModalContent context={{selectedRegistration, setRegistrationList}} onClose={() => setShowRegistrationDetailsModal(false)} />}
        style={styles['admin-registration-details-modal']} />
    </div>
  )
}

const renderStatus = (status, rejectReason) => {
  const rejectReasonFmt = rejectReason === '' ? '' : `(${rejectReason})`;
  switch(status){
    case REGISTRATION_PENDING_SUBMISSION:
      return 'Pending Investor Submission'
    case REGISTRATION_PENDING_CONFIRMATION:
      return 'Pending Broker Confirmation'
    case REGISTRATION_PENDING_PDTC_PROCESSING:
      return 'Pending for PDTC Processing'
    case REGISTRATION_BP_ASSIGNED:
      return 'BPID Assigned'
    case REGISTRATION_REJECTED:
      return `Rejected for Editing ${rejectReasonFmt}`;
    case REGISTRATION_CANCELLED:
      return `Cancelled`;
    default:
  }
}

export default AdminInvestorRegistrationList;
